import Layout from "@/components/shared/Layout";
import React from "react";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import Head from "next/head";
import Image from "next/image";
import QwasarPhoto from "../../public/images/qwasar-photo.png";
import Logo from "@/images/qwasar-logo.png";
import Quote from "@/images/quote.svg";
import ScrollAnimation from "@/components/shared/ScrollAnimation";
import ContactForm from "@/components/shared/ContactForm";
import WhatsappButton from '@/components/shared/WhatsappButton'

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale || "az")),
    },
  };
}

const Qwasar = () => {
  const { t } = useTranslation();

  const scrollToSection = (sectionId, position) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: position,
      });
    }
  };

  return (
    <>
      <Head>
        <title>Peerstack | Qwasar</title>
      </Head>
      <Layout scrollToSection={scrollToSection}>
        <div className="flex w-full flex-col">
          <div className="relative max-w-[90%] mx-auto w-full h-[400px]">
            <Image
              src={QwasarPhoto}
              alt="Qwasar Silicon Valley"
              fill
              className="object-cover rounded-[20px]"
              priority
            />
            <div className="absolute bottom-4 left-4 sm:bottom-6 sm:left-6 w-[170px] h-[50px] md:w-[275px] md:h-[84px] bg-white rounded-[6px] flex items-center justify-center">
              <Image
                src={Logo}
                alt="Qwasar Silicon Valley Logo"
                width={230}
                height={70}
                className="h-auto px-[15px] py-[5px]"
              />
            </div>
          </div>

          <div className="flex flex-col max-w-[90%] mx-auto w-full py-[32px]">
            <h1 className="text-[32px] md:text-[60px] lg:text-[80px] font-[500] text-black mb-[20px]">
              {t("qwasar_header")}
            </h1>

            <p className="text-[16px] font-[500] md:text-[18px]">
              {t("qwasar_main")}
            </p>

            <ul className="list-none px-[10px] font-[500] text-[18px]">
              <li>• {t("qwasar_bulletpoints_best_three")}</li>
              <li>• {t("qwasar_bulletpoints_twenty_years")}</li>
              <li>• {t("qwasar_bulletpoints_three_awards")}</li>
              <li>• {t("qwasar_bulletpoints_ap_csp")}</li>
              <li>• {t("qwasar_bulletpoints_incubation")}</li>
              <li>• {t("qwasar_bulletpoints_year_training")}</li>
            </ul>

            <div className="relative mt-[32px] rounded-[6px] border-[1.66px] border-[#7A72FF] bg-white px-[16px] py-[60px]">
              <p className="text-[16px] font-[600] md:text-[18px]">
                {t("qwasar_quote")}
              </p>
              <Image
                src={Quote}
                alt="quote"
                width={61}
                height={40}
                className="absolute right-[10px] top-[10px]"
              />
            </div>
          </div>
        </div>
        <ScrollAnimation>
          <ContactForm />
        </ScrollAnimation>
        <WhatsappButton />
      </Layout>
    </>
  );
};

export default Qwasar;
